import { Update } from '@ngrx/entity';
import { ChangeLogEntry, MonaTask, TaskType } from '@mona/models';
import { ChangeLogMap, mergeChangesOnModelId } from '@mona/pdms/data-access-changelog';

/**
 * @param changeLogMap
 */
export function getUpdateTasksToComplete(changeLogMap: ChangeLogMap): Update<MonaTask>[] {
    const procChanges = changeLogMap?.['Procedure'];
    const medChanges = changeLogMap?.['MedicationAdministration'];

    if (!procChanges && !medChanges) {
        return [];
    }

    const tasks: Update<MonaTask>[] = [];

    tasks.push(...createTypeTasksFromChanges(procChanges, TaskType.ProcedurePrescriptions));
    tasks.push(...createTypeTasksFromChanges(medChanges, TaskType.MedicationPrescriptions));

    return tasks;
}

/**
 * Marks tasks completed from changelog; skips UPDATE-only deltas missing date or prescriptionId.
 * @param changes
 * @param taskType
 */
export function createTypeTasksFromChanges(changes: ChangeLogEntry[], taskType: TaskType): Update<MonaTask>[] {
    const mergedChanges = mergeChangesOnModelId(changes);

    return (mergedChanges ?? []).reduce<Update<MonaTask>[]>((acc, { payload: prescription }) => {
        const date = taskType === TaskType.MedicationPrescriptions ? prescription?.startDate : prescription?.date;
        if (!date || !prescription?.prescriptionId) {
            return acc;
        }

        const timestamp = date.toISOString().split('.')[0] + 'Z';
        acc.push({
            id: `${timestamp}_${prescription.prescriptionId}_${taskType}`,
            changes: {
                isCompleted: true,
                change: { payload: prescription },
            },
        } as Update<MonaTask>);
        return acc;
    }, []);
}

/**
 * @param tasks
 */
export function createUpdateTasks(tasks: MonaTask[]): Update<MonaTask>[] {
    return tasks.map(task => ({
        id: task.id,
        changes: task,
    }));
}
